export default function (el, htmlOptions) {
    $('div.responsive-tabs').responsiveTabs({
        active: 0
    });
};
